import { render, staticRenderFns } from "./repairs.vue?vue&type=template&id=4bd968c5&"
import script from "./repairs.vue?vue&type=script&lang=js&"
export * from "./repairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports